<template>
	<div class="box box-projects">
		<div class="header">
			<span v-show="search.results.length">{{ search.results.length }} projet<span v-show="search.results.length > 1">s</span> trouvé<span v-show="search.results.length > 1">s</span></span>
			<div class="actions">
				<div class="action" @click="show_new_study_window()"><icon file="plus" :size="16" /> Nouveau projet</div>
			</div>
		</div>
		<div class="content">
			
			<div class="projects" v-if="search.results.length">
				<div class="scroll-wrap">
					<div class="scroll" v-bar>
						<div class="scroll-content" id="results-scroll">

							<row-project
								v-for="project in search.results"
								:project="project"
								:key="project.id"
								@mouseenter.native="mouseenter_project(project)"
								@mouseleave.native="mouseleave_project()"
							/>

						</div>
					</div>
				</div>
			</div>

			<div v-else class="no-data">
				<icon file="compass" :size="80" />
				<span>Aucun résultat à afficher</span>
			</div>

		</div>
	</div>
</template>

<script>
import { mapGetters } from "vuex";
import RowProject from "@/components/projects/row-project";
import $ from "jquery";

export default {
	name: "box-projects",
	data: function () {
		return {
		};
	},
	computed: {
		...mapGetters([ "app", "search" ]),
	},
	watch: {
		"search.active_project": function (newValue) {
			if (newValue) {
				this.$nextTick(function () {
					this.scroll_to_active_project();
				});
			}
		},
		"search.results": function () {
			if (this.search.active_project) {
				const result = _.find(this.search.results, { project_id: this.search.active_project.project_id });
				if (result) {
					this.$nextTick(function () {
						this.scroll_to_active_project();
					});
				}
			}
		}
	},
	methods: {
		show_new_study_window: function () {
			this.$store.dispatch("set_window", { name: "window-new-study" });
		},
		scroll_to_active_project: function (duration) {
			const $project = $("#results-scroll .row-project.expanded");
			if ($project.length) {
				if (_.isUndefined(duration)) duration = 500;
				const top = $project.get(0).offsetTop;
				$("#results-scroll").animate({ scrollTop: top }, duration);
			}
		},
		mouseenter_project: function (project) {
			if (project && project.project_id) {
				$("#map").find("#pin-project-" + project.project_id).addClass("active");
			}
		},
		mouseleave_project: function () {
			$("#map .map-icon").removeClass("active");
		}
	},
	mounted: function () {
		if (this.search.active_project) {
			this.$nextTick(function () {
				this.scroll_to_active_project();
			});
		}
	},
	components: { RowProject }
};
</script>

<style lang="stylus" scoped>
@import '../../assets/css/app'
@import '../../assets/css/grid'

.box-projects
	z-index 2
	box-shadow 3px 0 1px alpha(#000, 10%)

.projects
	height 100%

.no-data
	height 100%
	display flex
	align-items center
	justify-content center
	flex-direction column
	color #ccc
	font-weight 500
	text-transform uppercase
	cursor default
	.icon
		display block
		margin-bottom 8px

</style>